import { FaClock, FaMapMarkerAlt, FaUserTie, FaDollarSign, FaTags, FaBriefcase, FaCalendarAlt, FaPhone, FaUsers, FaEnvelope, FaHourglass, FaUtensils, FaGift, FaCalendarCheck, FaStar, FaBuilding, FaPaintBrush, FaGlobe, FaCalendarDay, FaLeaf, FaRing, FaSeedling, FaCamera, FaMusic, FaChurch, FaGlassCheers, FaGifts, FaCocktail, FaCreditCard } from 'react-icons/fa';
import { FaPersonDress } from 'react-icons/fa6';


// Function to render the appropriate icon based on the name
export const renderIcon = (iconName) => {

  // Convert the name to lowercase
  const lowercaseName = iconName.toLowerCase();

  // Check the lowercase name and return the corresponding icon component
  switch (lowercaseName) {

    /*----- Service Icons -----*/
    case 'wedding planning':
      return <FaRing />; // Ring icon

    case 'venue selection':
      return <FaBuilding />; // Building icon

    case 'floral design':
      return <FaSeedling />; // Seedling/plant icon

    case 'food catering':
      return <FaUtensils />; // Utensils icon

    case 'photo coverage':
      return <FaCamera />; // Camera icon

    case 'live music':
      return <FaMusic />; // Music note icon

    /*----- Events Icons -----*/
    case 'wedding ceremony':
      return <FaChurch />; // Church icon

    case 'reception party':
      return <FaGlassCheers />; // Clinking glasses icon

    case 'bridal shower':
      return <FaGifts />; // Gift boxes icon

    case 'engagement party':
      return <FaRing />; // Ring icon

    case 'bachelorette party':
      return <FaCocktail />; // Cocktail glass icon

    case 'rehearsal dinner':
      return <FaUtensils />; // Utensils icon

    /*----- Positions Icons -----*/
    case 'wedding planner':
      return <FaRing />; // Ring icon

    case 'event coordinator':
      return <FaCalendarCheck />; // Calendar with check icon

    case 'bridal stylist':
      return <FaCreditCard />; // Credit card icon

    case 'floral designer':
      return <FaLeaf />; // Leaf icon

    case 'venue coordinator':
      return <FaBuilding />; // Building icon

    case 'catering manager':
      return <FaUtensils />; // Utensils icon

    /*----- Vendors Category Icons -----*/
    case 'catering services':
      return <FaUtensils />; // Utensils icon

    case 'event photography':
      return <FaCamera />; // Camera icon

    case 'wedding venues':
      return <FaBuilding />; // Building icon

    case 'bridal attire':
      return <FaPersonDress />; // Dress icon

    case 'music entertainment':
      return <FaMusic />; // Music note icon

    /*----- Page Sidebar -----*/
    case 'date':
    case 'days':
    case 'deadline':
      return <FaCalendarAlt />; // Calendar icon

    case 'timing':
    case 'hours':
    case 'time':
    case 'businesshours':
      return <FaClock />; // Clock icon

    case 'duration':
      return <FaHourglass />; // Hourglass icon

    case 'client':
    case 'position':
      return <FaUsers />; // Users icon

    case 'category':
      return <FaTags />; // Tags icon

    case 'location':
      return <FaMapMarkerAlt />; // Location icon

    case 'salary':
    case 'pricerange':
    case 'cost':
      return <FaDollarSign />; // Dollar icon

    case 'experience':
      return <FaBriefcase />; // Briefcase icon

    case 'leadplanner':
      return <FaUserTie />; // Leader icon

    case 'phonenumber':
      return <FaPhone />; // Phone icon

    case 'email':
      return <FaEnvelope />; // Email icon

    case 'eventtype':
      return <FaCalendarDay />; // Calendar Day icon

    case 'includes':
      return <FaGift />; // Gift icon

    case 'booking':
    case 'availability':
      return <FaCalendarCheck />; // Calendar Check icon

    case 'specialfeatures':
    case 'specialties':
      return <FaStar />; // Star icon

    case 'website':
      return <FaGlobe />; // Globe icon

    case 'eventthemes':
      return <FaPaintBrush />; // Paintbrush icon

    default:
      return null; // Return null if no matching icon is found

  }

};